import { Component, OnInit, OnDestroy, ComponentFactoryResolver, Injector, ApplicationRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DateRange } from '../../shared/components/date-range/date-range.component';
import moment from 'moment';
import { TransactionLogService } from '../services/transaction-log.service';
import { handleError, getAlertMessage } from '../../shared/api-loaders';
import { Alert } from '../../shared/alert.model';
import { TransactionLog, TransactionLog_SubTransaction } from '../models/TransactionLog';
import { TransactionLogDetailComponent } from '../transaction-log-detail/transaction-log-detail.component';
import { getDefaultDataTableDefinition } from '../../shared/DataTablesHelper';
import { MessageType } from '../../shared/messageType';
import { MessageService } from '../../shared/message.service';
import { longDateFormat } from '../../shared/StringHelper';
import { Router, ActivatedRoute } from '@angular/router';
import { TransactionStatus, getStatusIconClassName, getStatusTextClassName } from '../models/TransactionStatus';
import { Select2Option } from '../../shared/select2-option';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { SecurityService } from '../../shared/security.service';
import { UserDetailService } from '../services/user-detail.service';
import { UserDetailOptionsFacility } from '../models/user-detail-options';

@Component({
    selector: 're-transaction-log',
    templateUrl: './transaction-log.component.html',
    styleUrls: ['./transaction-log.component.scss'],
    standalone: false
})
export class TransactionLogComponent implements OnInit, OnDestroy, AfterViewInit {



  dataTable: DataTables.Api;
  searchSubscription: Subscription;
  data: TransactionLog[];

  constructor(private transactionLogService: TransactionLogService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private app: ApplicationRef,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private securityService: SecurityService,
    private userDetailService: UserDetailService
  ) {
    let to = moment().endOf('day').toDate();
    let from = moment(to).subtract(1, 'month').startOf('day').toDate();
    this.date = new DateRange(from, to);
  }
  alert: Alert;
  load() {
    this.dataTable?.search("").draw(); //the search text will be used dataTableBeforeSend
  }

  ngOnDestroy(): void {
    delete window[ "currentComponent" ];
    this.searchSubscription.unsubscribe();
  }

  addDetailComponent(element: HTMLElement, data: TransactionLog) {
    let factory = this.resolver.resolveComponentFactory(TransactionLogDetailComponent);

    const ref = factory.create(this.injector, [], element);
    ref.instance.transactionLog = data;
    ref.instance.resolved.subscribe((x: number) => {
      this.resolve(x);
    });
    this.app.attachView(ref.hostView);
  }



  ngAfterViewInit(): void {
    this.searchControlFocus();
    let searchInput = this.searchControl.nativeElement as HTMLInputElement;
    this.searchSubscription = fromEvent(searchInput, "input")
      .pipe(
        debounceTime(500),
        filter(v => this.searchText.length >= 3 || this.searchText.length == 0)
      ).subscribe(x => {
        this.load();
      })
  }

  isLocationAdmin = false;
  selectedLocationName = "";
  async ngOnInit() {
    $(function () {
      $('[data-toggle="tooltip"]')["tooltip"]();
    });

    this.isLocationAdmin = await this.securityService.isUserManagementLocalAdmin().toPromise();


    if (this.isLocationAdmin) {

      try {
        this.showSpinner();

        let options = await this.userDetailService.getOptions().toPromise();
        let facilities = new Array<UserDetailOptionsFacility>();

        options.map(x => x.facilities).forEach(corpFacilities => {
          corpFacilities.forEach(facility => {
            facilities.push(facility);
          })

        })


        this.locationOptions = facilities.map<Select2Option>(x => ({ id: x.name, text: x.name }));
        this.selectedLocation = this.locationOptions[ 0 ].id;
        this.selectedLocationName = this.locationOptions[ 0 ].text;
      } catch (e) {
        this.alert = getAlertMessage(e);
      }
      finally {
        this.hideSpinner();
      }
    }
    this.route.queryParams.subscribe(x => { //so we can handle the navigate to the same route
      this.queryParamSearch = x.search;
      if (this.dataTable) {
        this.load();
      }
    });

    window[ "currentComponent" ] = this;
    let localDateInfo = `
            <a class="ml-2" href="javascript:void(0)" data-toggle="tooltip" data-placement="right" title="In local timezone based on device">
                <span class="text-primary fa-solid fa-circle-info"></span>
            </a>`;

    this.dataTable = getDefaultDataTableDefinition("#errorList",
      {
        ajax: (data, callback, settings) => this.dataCallback(data, callback, settings),
        columns: [

          {
            width: '150px',
            className: 'details-control', name: 'user', title: 'Transaction Id', render: (data: any, type: any, e: TransactionLog) => {
              return `<span class='ml-3'>${e.transactionId}</span>`;
            }
          },
          {
            width: '150px',
            name: 'transactionType', title: 'Transaction Type', render: (data: any, type: any, e: TransactionLog) => {
              return `${e.type}`;
            }
          },
          {
            name: 'name', title: 'Name', render: (data: any, type: any, e: TransactionLog) => {
              return e.isUserDeleted ? `${e.userFirstName} ${e.userLastName}` : `<a href="javascript:currentComponent.navigateToUser('${e.ssoid}')">${e.userFirstName} ${e.userLastName} <a>`;
            }
          },
          {
            name: 'status', width: '150px', title: 'Status', render: (data: any, type: any, e: TransactionLog) => {
              return `<span class="mr-2 ${getStatusIconClassName(e.statusName)}"></span><span class="${getStatusTextClassName(e.statusName)}">${e.statusName}</span>`;
            }
          },
          {
            name: 'startDate', title: `Start Date`, render: (data: any, type: any, e: TransactionLog) => {
              return `${longDateFormat(e.startDate)}`;
            }
          },
          {
            name: 'endDate', title: `End Date`, render: (data: any, type: any, e: TransactionLog) => {
              return `${longDateFormat(e.endDate) || '<span class="in-progress">In Progress<span>'}`;
            }
          },
          {
            name: 'initiatedBy', title: 'Initiated By', render: (data: any, type: any, e: TransactionLog) => {
              return `${e.createdByFirstName} ${e.createdByLastName}`;
            }
          },

        ]
      });


    $('#errorList tbody').on('click', 'td.details-control', function () {
      var component: TransactionLogComponent = window[ "currentComponent" ];
      var tr = $(this).closest('tr');
      var row = component.dataTable.row(tr);

      if (row.child.isShown()) {
        // This row is already open - close it
        row.child.hide();
        tr.removeClass('shown');
      }
      else {
        // Open this row
        let data = <TransactionLog>row.data();
        let parentElement = document.createElement("div");
        row.child(parentElement).show();
        component.addDetailComponent(parentElement, data);
        //row.child(component.format(<ErrorLog>row.data())).show();
        tr.addClass('shown');
      }
    });
    setTimeout(() => {
      this.load();
    }, 0);


  }

  private showSpinner() {
    this.messageService.send(MessageType.ProcessingOn);

  }

  private hideSpinner() {
    this.messageService.send(MessageType.ProcessingOff);

  }

  private navigateToUser(ssoId) {
    this.router.navigate([ "/user", ssoId ]);
  }

  selectedStatusChanged($event) {
    this.load();
  }
  selectedStatus: string = "errors";
  statusOptions: Select2Option[] = [
    { text: 'Show All', id: 'all' },
    { text: 'Show Errors', id: 'errors' },
    { text: 'Show In Progress', id: 'inprogress' },
  ];

  locationOptions: Select2Option[];

  selectedLocationChanged($event) {
    this.selectedLocationName = this.locationOptions.firstOrDefault(x => x.id == this.selectedLocation).text;
    this.load();
  }
  selectedLocation: string = "";

  handleCitusBusResponse(subTransactions: TransactionLog_SubTransaction[]) {
    subTransactions.forEach(subTransaction => {
      if(subTransaction) {
        if(subTransaction.productName === "MESSAGE_BUS") {
          // Set to null or parse the JSON if you want to extract specific parts
          if (subTransaction.statusDescription && subTransaction.statusDescription.indexOf("{") >= 0) {
            try {
              const json = JSON.parse(subTransaction.statusDescription);
              subTransaction.statusDescription = json.message || null;
            } catch (e) {
              subTransaction.statusDescription = null;
            }
          }
        }
      }
    });
  }

  dataCallback(data: any, callback: (data: any) => void, settings: DataTables.Settings): void {
    //setTimeout(() => {
    this.showSpinner();
    this.transactionLogService.getTransactions(this.date, this.selectedStatus, this.queryParamSearch ?? this.searchText, data.start / data.length, data.length, this.selectedLocation)
      .subscribe(x => {
        x.data.forEach(trans => {
          trans.subTransactions.forEach(subTransaction => {
            if (subTransaction.productName === 'SNF') {
              subTransaction.productName = 'MatrixCare 360';
            }
          });
          this.handleCitusBusResponse(trans.subTransactions);
        });
        this.hideSpinner();
        callback(x);
        this.data = x.data;
      }, error => {
        this.hideSpinner();
        // console.log("error while suspending an user");
        this.alert = getAlertMessage(error);
      });
    //}, 0);

  }


  @ViewChild('searchControl') searchControl: ElementRef;
  searchControlFocus() {
    setTimeout(() => {
      this.searchControl.nativeElement.focus();
    }, 500);
  }

  dateChanged(date) {
    this.load();
  }

  search() {
    this.load();
  }

  retry(userId: number) {
    alert(`Retrying user ${userId}`);
  }
  retryAll() {
    alert(`Retrying all users`);
  }

  resolve(subTransactionId: number) {
    this.showSpinner();
    this.transactionLogService.resolve(subTransactionId)
      .subscribe(x => {
        this.search();
      }, error => {
        this.hideSpinner();
        this.alert = getAlertMessage(error);
      });

  }
  collpseAll() {
    this.openCloseSection(false);
  }

  expandAll() {
    this.openCloseSection(true);
  }
  searchText: string;
  date: DateRange;
  queryParamSearch: string;

  private openCloseSection(open: boolean) {
    $('#errorList tbody td.details-control').each((i: number, element: HTMLElement) => {
      if (open && !element.parentElement.classList.contains('shown')) {
        element.click();
      }
      if (!open && element.parentElement.classList.contains('shown')) {
        element.click();
      }
    });
  }

  back() {
    window.history.back();
  }
}
